// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ni-0";
export var assigneeDetails = "_ni-1";
export var assigneeInfo = "_ni-2";
export var dropdownContainer = "_ni-4";
export var dropdownImage = "_ni-5";
export var editAssigneeInfo = "_ni-3";
export var editAssigneeModalContainer = "_ni-6";
export var hidden = "_ni-8";
export var input = "_ni-7";